import styled from "styled-components";

export const IconContainer = styled.div<{ $disableMaxHeight?: boolean; $isActive?: boolean; $clickable?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: ${({ $disableMaxHeight }) => ($disableMaxHeight ? "none" : "16px")};
	max-height: ${({ $disableMaxHeight }) => ($disableMaxHeight ? "none" : "16px")};
	cursor: ${({ $clickable }) => ($clickable ? "pointer" : "inherit")};

	&.linkOut {
		color: ${({ theme }) => theme.textSecondary};

		path {
			stroke: #969ba0;
		}

		${({ $isActive, theme }) => $isActive && `stroke: ${theme.textDetails};`}
	}
`;

export const ItemRotation = styled.div`
	transition: transform 200ms;

	&:hover {
		transform: rotate(45deg);
	}
`;

export const XIcon = styled.div`
	color: #cccccc;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 200ms;

	&:hover {
		color: #999999;
	}
`;
